module.exports = __webpack_public_path__ + "static/media/TABtouch_transparent.759847b9.png";